'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectHasBannersQueued = exports.selectBannerToDisplay = exports.addGenericNotification = exports.addFailureNotification = exports.addSuccessNotification = exports.addNotification = exports.addAnnouncement = exports.addBanner = exports.removeBanner = exports.clearAllBanners = exports.REMOVE_BANNERS = exports.ADD_BANNER = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.reducer = reducer;

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR_ALL_BANNERS = 'classpass/banner_2/CLEAR_ALL_BANNERS';
var ADD_BANNER = exports.ADD_BANNER = 'classpass/banner_2/ADD';
var REMOVE_BANNERS = exports.REMOVE_BANNERS = 'classpass/banner_2/REMOVE';

var clearAllBanners = exports.clearAllBanners = function clearAllBanners() {
  return { type: CLEAR_ALL_BANNERS };
};
var removeBanner = exports.removeBanner = function removeBanner() {
  for (var _len = arguments.length, bannerIds = Array(_len), _key = 0; _key < _len; _key++) {
    bannerIds[_key] = arguments[_key];
  }

  return { type: REMOVE_BANNERS, data: bannerIds };
};

var addBanner = exports.addBanner = function addBanner(category, component, props) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    type: ADD_BANNER,
    data: {
      id: options.id || (__TEST__ ? 1 : String(Math.round(Math.random() * 100000000))),
      category: category,
      component: component,
      props: props,
      options: (0, _extends3.default)({
        priority: 1
      }, options)
    }
  };
};

var addAnnouncement = exports.addAnnouncement = function addAnnouncement(id, component, props) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref2$priority = _ref2.priority,
      priority = _ref2$priority === undefined ? 1 : _ref2$priority,
      _ref2$timeout = _ref2.timeout,
      timeout = _ref2$timeout === undefined ? 0 : _ref2$timeout,
      _ref2$removeAfterNavi = _ref2.removeAfterNavigations,
      removeAfterNavigations = _ref2$removeAfterNavi === undefined ? null : _ref2$removeAfterNavi,
      _ref2$suppressible = _ref2.suppressible,
      suppressible = _ref2$suppressible === undefined ? null : _ref2$suppressible;

  return addBanner('announcement', component, props, {
    priority: priority,
    timeout: timeout,
    removeAfterNavigations: removeAfterNavigations,
    suppressible: suppressible,
    id: id
  });
};

var addNotification = function addNotification(component, props) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _ref$priority = _ref.priority,
      priority = _ref$priority === undefined ? 1 : _ref$priority,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
      _ref$removeAfterNavig = _ref.removeAfterNavigations,
      removeAfterNavigations = _ref$removeAfterNavig === undefined ? 1 : _ref$removeAfterNavig,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['priority', 'timeout', 'removeAfterNavigations']);
  return addBanner('notification', component, props, (0, _extends3.default)({
    priority: priority,
    timeout: timeout,
    removeAfterNavigations: removeAfterNavigations
  }, rest));
};

exports.addNotification = addNotification;
var addSuccessNotification = exports.addSuccessNotification = function addSuccessNotification(message, options) {
  return addNotification('SuccessNotification', { message: message }, options);
};
var addFailureNotification = exports.addFailureNotification = function addFailureNotification(message, options) {
  return addNotification('FailureNotification', { message: message }, options);
};
var addGenericNotification = exports.addGenericNotification = function addGenericNotification(message, options) {
  return addNotification('GenericNotification', { message: message }, options);
};

var selectBannerToDisplay = exports.selectBannerToDisplay = function selectBannerToDisplay(category, state) {
  return state.banners.find(function (banner) {
    return banner.category === category;
  });
};
var selectHasBannersQueued = exports.selectHasBannersQueued = function selectHasBannersQueued(state) {
  return !!state.banners.length;
};

var initialState = [];

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CLEAR_ALL_BANNERS:
      return [];
    case ADD_BANNER:
      {
        var _action$data = action.data,
            id = _action$data.id,
            options = _action$data.options,
            rest = (0, _objectWithoutProperties3.default)(_action$data, ['id', 'options']);


        var seenIds = {};

        return state.concat((0, _extends3.default)({
          id: id
        }, rest, options, {
          navigationsSinceAdded: 0
        })).reduce(function (banners, banner) {
          if (!(banner.id in seenIds)) {
            seenIds[banner.id] = true;
            banners.push(banner);
          }
          return banners;
        }, []).sort(function (a, b) {
          return b.priority - a.priority;
        });
      }

    case REMOVE_BANNERS:
      return state.filter(function (banner) {
        return !action.data.includes(banner.id);
      });

    case _reactRouterRedux.LOCATION_CHANGE:
      return state.map(function (banner) {
        return (0, _extends3.default)({}, banner, {
          navigationsSinceAdded: banner.navigationsSinceAdded + 1
        });
      }).filter(function (banner) {
        return !banner.removeAfterNavigations || banner.navigationsSinceAdded < banner.removeAfterNavigations;
      });
    default:
      return state;
  }
}